import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
//import { Box, Card, Divider } from '@mui/material';
import styled from '@emotion/styled';
import Typography from '../../../theme/overrides/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const CardWidget = styled("Card")({
    backgroundColor: `rgba(255, 255, 255, 1)`,
    boxShadow: `0px 0px 15px rgba(0, 0, 0, 0.05)`,
    borderRadius: `23px`,
    //width: `463px`,
   // height: `497px`,
    //position: `absolute`,
    //left: `0px`,
    //top: `0px`,
    width: '100%', // Set the width to 90% of the parent container
    height: '100%', // Automatically adjust the height based on content
    margin: '0 auto', // Center the card horizontally
    padding: '16px',
  });

  const Card = styled("div")({
    backgroundColor: `rgba(255, 255, 255, 1)`,
    boxShadow: `0px 0px 15px rgba(0, 0, 0, 0.05)`,
    borderRadius: `34px`,
    width: '100%', // Set the width to 90% of the parent container
    height: '100%', // Automatically adjust the height based on content
    margin: '0 auto', // Center the card horizontally
   // padding: '16px',
  });
  

export default function TrainerCalendarDashboard() {
  return (
    <Card>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar />
     {/* <Divider />
      <Box textAlign="center" mt={2}>
        <Typography variant="subtitle1" color="primary" style={{ cursor: 'pointer' }}>
            See your Today's Schedule <ArrowForwardIcon fontSize="small" />
        </Typography>
  </Box> */}
    </LocalizationProvider>
    </Card>
  );
}